import RouteError from '@/components/ui/route-error';
import { createFileRoute } from '@tanstack/react-router';
import DashboardRouteLayout from '@/app/components/dashboard-route-layout';
import DashboardPageShell from '@/app/components/dashboard-page-shell';
import { DICTIONARY } from '@/config/dictionary';
import { requireAuth } from '@/utils/require-auth-before-load';
import { queryClient } from '@/lib/query-client';
import ApiKeysAdminTab from '@/features/admin-settings/components/api-keys-admin-tab';
import { getApiKeysQueryOptions } from '@/features/admin-settings/api/api-keys-api';

const d = DICTIONARY.adminSettingsPage.apiKeysAdmin;

const ApiKeysAdminPage = () => (
  <DashboardRouteLayout>
    <DashboardPageShell title={d.pageTitle} description={d.pageDescription}>
      <ApiKeysAdminTab />
    </DashboardPageShell>
  </DashboardRouteLayout>
);

export const Route = createFileRoute('/admin-settings/api-keys-admin')({
  beforeLoad: requireAuth,
  loader: async () => {
    await queryClient.prefetchQuery(getApiKeysQueryOptions());
    return null;
  },
  component: ApiKeysAdminPage,
  errorComponent: RouteError,
});
